// Mirrors the header's hide-on-scroll-down / show-on-scroll-up behavior,
// so pinned UI (like the Services jump nav) can follow the header.
import { useState } from "react";
import { useScroll, useMotionValueEvent } from "framer-motion";

export const useHeaderHidden = () => {
  const { scrollY } = useScroll();
  const [hidden, setHidden] = useState(false);
  useMotionValueEvent(scrollY, "change", (y) => {
    const prev = scrollY.getPrevious() ?? 0;
    setHidden(y > prev && y > 160);
  });
  return hidden;
};
